// extracted by mini-css-extract-plugin
export default {"buttonResposta":"RespostasComponent_buttonResposta__SIRK5"};